import { StorageKobraService } from 'src/app/core/http/storage-kobra/storage-kobra.service';
import { Injectable } from '@angular/core';
import { environmentSelector } from '../../environments/environment.selector';
import { LoadingService } from '../shared/components/loading-bar/loading-bar.service';
import { ServicesVisitasService } from 'src/app/core/http/services-visitas/services-visitas.service';
import { NewStorageKobraService } from 'src/app/core/http/new-storage-kobra/new-storage-kobra.service';
import { IDescargaDetalle } from './descargas.interface';

@Injectable()
export class DescargasService {
  public apiService = '/v2/agents';


  constructor(
    private servicesStorage: StorageKobraService,
    private loadingService: LoadingService,
    private visitasService: ServicesVisitasService,
    private newStorageService: NewStorageKobraService
    
  ) { }


  public obtenerDescargas(idClienteAdministrador:number, queryParams: string){
    return this.visitasService.get(`/usuarios/${idClienteAdministrador}/descargas${queryParams}`);
  }


  /**
   * Obtiene los detalles de una descarga específica
   * @param idDescarga ID de la descarga
   * @returns Observable con los detalles de la descarga
   */
  public obtenerDetalleDescarga(idDescarga: number) {
    return this.visitasService.get(`/descargas/${idDescarga}`);
  }

  /**
   * Descarga un archivo usando el nuevo flujo:
   * 1. Obtiene los metadatos del archivo desde descargas/${idDescarga}
   * 2. Usa getFileByFullPathAsBlob para obtener el archivo directamente como blob
   * 3. Descarga el archivo desde el blob
   * @param idDescarga ID de la descarga
   * @param nombreOriginal Nombre original del archivo para guardar
   * @returns Promise que se resuelve cuando la descarga se completa
   */
  public descargarArchivo(idDescarga: number, nombreOriginal: string): Promise<void> {
    this.loadingService.setLoading(true);
    return new Promise((resolve, reject) => {
      // Paso 1: Obtener los metadatos del archivo
      this.obtenerDetalleDescarga(idDescarga).subscribe(
        (response: any) => {
          const detalle: IDescargaDetalle = response.data || response;
          
          // Paso 2: Construir la ruta completa del archivo
          const rutaCompleta = `${detalle.ruta}/${detalle.nombreArchivo}`;
          
          // Paso 3: Usar getFileByFullPathAsBlob para obtener el archivo directamente como blob
          this.newStorageService.getFileByFullPathAsBlob(rutaCompleta).subscribe(
            (blob: Blob | null) => {
              if (blob) {
                // Paso 4: Descargar el archivo desde el blob
                this.descargarArchivoDesdeBlob(blob, nombreOriginal);
                this.loadingService.setLoading(false);
                resolve();
              } else {
                console.error('No se pudo obtener el archivo como blob');
                this.loadingService.setLoading(false);
                reject(new Error('No se pudo obtener el archivo'));
              }
            },
            error => {
              console.error('Error al obtener el archivo como blob:', error);
              this.loadingService.setLoading(false);
              reject(error);
            }
          );
        },
        error => {
          console.error('Error al obtener los detalles de la descarga:', error);
          this.loadingService.setLoading(false);
          reject(error);
        }
      );
    });
  }

  /**
   * Descarga un archivo desde un blob
   * @param blob Blob del archivo
   * @param nombreArchivo Nombre del archivo para la descarga
   */
  private descargarArchivoDesdeBlob(blob: Blob, nombreArchivo: string): void {
    // Crear URL temporal del blob y descargar
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = blobUrl;
    a.download = nombreArchivo;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(blobUrl);
    document.body.removeChild(a);
    
  }

  /**
   * Descarga un archivo desde una URL como blob
   * @param url URL del archivo
   * @param nombreArchivo Nombre del archivo para la descarga
   * @returns Promise que se resuelve cuando la descarga se completa
   */
  private descargarArchivoDesdeUrl(url: string, nombreArchivo: string): Promise<void> {
    return new Promise((resolve, reject) => {
      fetch(url)
        .then(response => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.blob();
        })
        .then(blob => {
          this.descargarArchivoDesdeBlob(blob, nombreArchivo);
          resolve();
        })
        .catch(error => {
          console.error('Error al descargar el archivo:', error);
          reject(error);
        });
    });
  }
}
